import React from "react";
import { BsBoxArrowInUpRight } from "react-icons/bs";
import {
  HomeIcon,
  FolderIcon as FolderIconOutline,
  ClipboardListIcon,
  BookOpenIcon,
  ChartPieIcon
} from "@heroicons/react/outline";
import useNav from "../../../../hooks/useNav";

const HouseholdLink = ({ data }) => {
  const nav = useNav();

  const navigationItems = [
    {
      icon: HomeIcon,
      path: 'dashboard',
      label: 'Dashboard',
      colorClass: 'text-orange-600 bg-orange-100 hover:bg-orange-200'
    },
    {
      icon: ChartPieIcon,
      path: 'youvest',
      label: 'YouVest',
      colorClass: 'text-purple-600 bg-purple-100 hover:bg-purple-200',
      customPath: `/crm/youvest/${data?.household_id}/My Portfolio`
    },
    {
      icon: BookOpenIcon,
      path: 'financial-story',
      label: 'Financial Story',
      colorClass: 'text-green-600 bg-green-100 hover:bg-green-200'
    },
    {
      icon: ClipboardListIcon,
      path: 'notes',
      label: 'Notes',
      colorClass: 'text-blue-600 bg-blue-100 hover:bg-blue-200'
    },
    {
      icon: FolderIconOutline,
      path: 'vault',
      label: 'Vault',
      colorClass: 'text-yellow-600 bg-yellow-100 hover:bg-yellow-200'
    }
  ];

  return (
    <>
      {" "}
      {data?.household_id ? (
        <div className="group relative">
          <button
            onClick={() => {
              nav(`/crm/households/${data.household_id}/advisor`);
            }}
            className="flex items-center text-left px-2 truncate w-full"
          >
            <p className="font-semibold">{data.household_name}</p>{" "}
            <BsBoxArrowInUpRight className="ml-1 h-3 w-3 flex-shrink-0" />
          </button>

          <div className="absolute right-0 top-0 flex items-center gap-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none group-hover:pointer-events-auto z-10">
            {navigationItems.map(({ icon: Icon, path, label, colorClass, customPath }) => (
              <button
                key={path}
                onClick={() => {
                  nav(customPath || `/crm/households/${data.household_id}/${path}`);
                }}
                className={`p-1 rounded-full transition-colors ${colorClass}`}
                title={label}
              >
                <Icon className="h-3 w-3" />
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div>

        </div>
      )}{" "}
    </>
  );
};

export default HouseholdLink;
